var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/BasePopup/BasePopup.jinja"] = require( "front/components/BasePopup/BasePopup.jinja" );
dependencies["front/components/CommonStory/CommonStory.jinja"] = require( "front/components/CommonStory/CommonStory.jinja" );
dependencies["front/components/CommonMap/CommonMap.jinja"] = require( "front/components/CommonMap/CommonMap.jinja" );
dependencies["front/components/CommonEventsList/CommonEventsList.jinja"] = require( "front/components/CommonEventsList/CommonEventsList.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/EventsPopup/EventsPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/EventsPopup/EventsPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/BasePopup/BasePopup.jinja", true, "assets/app/front/pages/EventsPopup/EventsPopup.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
parentTemplate = t_5
for(var t_4 in parentTemplate.blocks) {
context.addBlock(t_4, parentTemplate.blocks[t_4]);
}
output += "\n\n";
env.getTemplate("front/components/CommonStory/CommonStory.jinja", false, "assets/app/front/pages/EventsPopup/EventsPopup.jinja", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(Object.prototype.hasOwnProperty.call(t_7, "CommonStory")) {
var t_10 = t_7.CommonStory;
} else {
cb(new Error("cannot import 'CommonStory'")); return;
}
context.setVariable("CommonStory", t_10);
output += "\n";
env.getTemplate("front/components/CommonMap/CommonMap.jinja", false, "assets/app/front/pages/EventsPopup/EventsPopup.jinja", false, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
t_11.getExported(function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
if(Object.prototype.hasOwnProperty.call(t_11, "CommonMap")) {
var t_14 = t_11.CommonMap;
} else {
cb(new Error("cannot import 'CommonMap'")); return;
}
context.setVariable("CommonMap", t_14);
output += "\n";
env.getTemplate("front/components/CommonEventsList/CommonEventsList.jinja", false, "assets/app/front/pages/EventsPopup/EventsPopup.jinja", false, function(t_16,t_15) {
if(t_16) { cb(t_16); return; }
t_15.getExported(function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
if(Object.prototype.hasOwnProperty.call(t_15, "CommonEventsList")) {
var t_18 = t_15.CommonEventsList;
} else {
cb(new Error("cannot import 'CommonEventsList'")); return;
}
context.setVariable("CommonEventsList", t_18);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupContent"))(env, context, frame, runtime, function(t_20,t_19) {
if(t_20) { cb(t_20); return; }
output += t_19;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupContent(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"EventsPopup ";
if(!env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"other"))) {
output += "EventsPopup--no-other";
;
}
output += "\">\n        <div class=\"EventsPopup-headerImage\" data-animation=\"1\" data-animation-type=\"bubble-down\" data-animation-state=\"initial\">\n            <div class=\"EventsPopup-headerImageWrapper\">\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"cover")) {
output += "<img src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"cover")),"w1366_url"), env.opts.autoescape);
output += "\"\n                  srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"cover")),"w1920_url"), env.opts.autoescape);
output += " 1920w,\n                          ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"cover")),"w1680_url"), env.opts.autoescape);
output += " 1680w,\n                          ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"cover")),"w1366_url"), env.opts.autoescape);
output += " 1366w,\n                          ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"cover")),"w920_url"), env.opts.autoescape);
output += " 920w,\n                          ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"cover")),"w680_url"), env.opts.autoescape);
output += " 680w\"\n                  sizes=\"(max-width: 759px) 1, ";
output += "\n                         (min-width: 760px) and (max-width: 979px) 681, ";
output += "\n                         calc(100% - 240px)\" ";
output += "\n                  alt=\"\">\n                ";
;
}
else {
output += "\n                    <div class=\"EventsPopup-headerImagePattern\">\n                    </div>\n                ";
;
}
output += "\n            </div>\n        </div>\n        <div class=\"EventsPopup-infoBar\">\n            <div class=\"EventsPopup-infoBarWrapper ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"time") || !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"date")) {
output += "EventsPopup-infoBarWrapper--noTime";
;
}
output += " ";
if((!(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"location") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"location")),"address"))) && (!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"place"))) {
output += "EventsPopup-infoBarWrapper--noPlace";
;
}
output += "\">\n                <div class=\"EventsPopup-infoBarItem EventsPopup-infoBarItem--Date\">\n                    <div class=\"EventsPopup-infoBarItem-Title\">\n                        Date:\n                    </div>\n                    <div class=\"EventsPopup-infoBarItem-Info\">\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"date")) {
output += "\n                            ";
var t_21;
t_21 = false;
frame.set("makeStartAndEndDaysTheSame", t_21, true);
if(frame.topLevel) {
context.setVariable("makeStartAndEndDaysTheSame", t_21);
}
if(frame.topLevel) {
context.addExport("makeStartAndEndDaysTheSame", t_21);
}
output += "\n\n                            ";
output += "\n                            ";
output += "\n                            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"time") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"timeEnd")) {
output += "\n                                ";
var t_22;
t_22 = (lineno = 41, colno = 58, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "timeRange"), "timeRange", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"date"),false,runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"time"),false,"%H:%M"]));
frame.set("timeStart", t_22, true);
if(frame.topLevel) {
context.setVariable("timeStart", t_22);
}
if(frame.topLevel) {
context.addExport("timeStart", t_22);
}
output += "\n                                ";
var t_23;
t_23 = (lineno = 42, colno = 56, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "timeRange"), "timeRange", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"dateEnd"),false,runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"timeEnd"),false,"%H:%M"]));
frame.set("timeEnd", t_23, true);
if(frame.topLevel) {
context.setVariable("timeEnd", t_23);
}
if(frame.topLevel) {
context.addExport("timeEnd", t_23);
}
output += "\n                                ";
if(runtime.contextOrFrameLookup(context, frame, "timeStart") > runtime.contextOrFrameLookup(context, frame, "timeEnd")) {
output += " ";
output += "\n                                    ";
var t_24;
t_24 = true;
frame.set("makeStartAndEndDaysTheSame", t_24, true);
if(frame.topLevel) {
context.setVariable("makeStartAndEndDaysTheSame", t_24);
}
if(frame.topLevel) {
context.addExport("makeStartAndEndDaysTheSame", t_24);
}
output += "\n                                ";
;
}
output += "\n                            ";
;
}
output += "\n\n                            ";
if(runtime.contextOrFrameLookup(context, frame, "makeStartAndEndDaysTheSame")) {
output += "\n                                ";
output += runtime.suppressValue((lineno = 49, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "dateRange"), "dateRange", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"date"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"date"),"%b %d"])), env.opts.autoescape);
output += "\n                            ";
;
}
else {
output += "\n                                ";
output += runtime.suppressValue((lineno = 51, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "dateRange"), "dateRange", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"date"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"dateEnd"),"%b %d"])), env.opts.autoescape);
output += "\n                            ";
;
}
output += "\n                        ";
;
}
else {
output += "\n                            <span style=\"font-weight: 400\">TBD</span>\n                        ";
;
}
output += "\n                    </div>\n                </div>\n                <div class=\"EventsPopup-infoBarItem EventsPopup-infoBarItem--Time\">\n                    <div class=\"EventsPopup-infoBarItem-Title\">\n                        Time:\n                    </div>\n                    <div class=\"EventsPopup-infoBarItem-Info\">\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"date")) {
output += "\n                            ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 64, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "timeRange"), "timeRange", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"date"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"dateEnd"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"time"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"timeEnd"),"%I:%M<span>%p</span>"]))), env.opts.autoescape);
output += "\n                        ";
;
}
output += "\n                    </div>\n                </div>\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"location") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"location")),"latlng")) {
output += "<a href=\"\" target=\"_blank\" class=\"EventsPopup-infoBarItem EventsPopup-infoBarItem--Place\">\n                ";
;
}
else {
output += "<div class=\"EventsPopup-infoBarItem EventsPopup-infoBarItem--Place\">\n                ";
;
}
output += "<div class=\"EventsPopup-infoBarItem-Title\">\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"place"), env.opts.autoescape);
output += "\n                    </div>\n                    <div class=\"EventsPopup-infoBarItem-Info\">\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"location") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"location")),"address")) {
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"location")),"address")), env.opts.autoescape);
output += "\n                        ";
;
}
output += "</div>\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"location") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"location")),"latlng")) {
output += "</a>\n                ";
;
}
else {
output += "</div>\n                ";
;
}
output += "<div class=\"EventsPopup-infoBarItem EventsPopup-infoBarItem--Btns\">\n                    <div class=\"EventsPopup-infoBarItem-Inner\">\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"calendar")) {
output += "<a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"calendar"), env.opts.autoescape);
output += "\" class=\"EventsPopup-infoBarItem-Calendar ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"email")) {
output += "EventsPopup-infoBarItem-Calendar--fullwidth";
;
}
output += "\">Add to calendar</a>\n                        ";
;
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"email")) {
output += "<div class=\"EventsPopup-infoBarItem-EmailWrapper ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"calendar")) {
output += "EventsPopup-infoBarItem-EmailWrapper--fullwidth";
;
}
output += "\">\n                            <a href=\"mailto:";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"email"), env.opts.autoescape);
output += "\" class=\"EventsPopup-infoBarItem-Email \">E-mail to Rsvp</a>\n                        </div>\n                        ";
;
}
output += "</div>\n                </div>\n            </div>\n        </div>\n        <div class=\"EventsPopup-title\"><a href=\"";
output += runtime.suppressValue((lineno = 100, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:events"])), env.opts.autoescape);
output += "\">Events</a></div>\n        <h2 class=\"EventsPopup-caption\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"title"), env.opts.autoescape);
output += "</h2>\n\n        <div class=\"EventsPopup-content\">\n            ";
output += runtime.suppressValue((lineno = 104, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonStory"), "CommonStory", context, [runtime.makeKeywordArgs({"data": {"content": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"content"),"contenthtml": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"contenthtml")}})])), env.opts.autoescape);
output += "\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"location") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"location")),"latlng")) {
output += "<h3 class=\"EventsPopup-mapTitle\">Location:</h3>\n                ";
output += runtime.suppressValue((lineno = 108, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonMap"), "CommonMap", context, [runtime.makeKeywordArgs({"data": {"place": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"place"),"location": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"location")},"noBottomMargin": !env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"other"))})])), env.opts.autoescape);
output += "\n            ";
;
}
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"other"))) {
output += runtime.suppressValue((lineno = 112, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonEventsList"), "CommonEventsList", context, [runtime.makeKeywordArgs({"data": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"other"),"title": "More " + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"section") + " events:"})])), env.opts.autoescape);
output += "\n            ";
;
}
output += "</div>\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_popupContent: b_popupContent,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/EventsPopup/EventsPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/EventsPopup/EventsPopup.jinja
// module id = 533
// module chunks = 0